import { NgModule } from "@angular/core";
import { UserListComponent } from "./user-list/user-list.component";
import { RouterModule } from "@angular/router";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { CoreCommonModule } from "../../../@core/common.module";
import { NgxDatatableModule } from "@siemens/ngx-datatable";
import { NgSelectModule } from "@ng-select/ng-select";
import { AuthGuard } from "../../util/guard/auth.guard";
import { UserModalComponent } from "./user-modal/user-modal.component";
import { OwnUserModalComponent } from "./own-user-modal/own-user-modal.component";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { ComponentsModule } from "../../util/components/components.module";
import { NgbAlertModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { OfficesResolver } from "../../util/resolver/offices.resolver";

const routes = [
  {
    path: "users",
    component: UserListComponent,
    canActivate: [AuthGuard],
    resolve: {
      offices: OfficesResolver,
    },
  },
];

@NgModule({
  declarations: [UserListComponent, UserModalComponent, OwnUserModalComponent],
  imports: [
    RouterModule.forChild(routes),
    ContentHeaderModule,
    CoreCommonModule,
    NgxDatatableModule,
    NgSelectModule,
    SweetAlert2Module,
    ComponentsModule,
    NgbNavModule,
    NgbAlertModule,
  ],
})
export class UsersModule {}
